<template>
  <div>
    <topbar title="Guida" :largeTitle="true" :showBack="true" @back="$router.go(-1)" />
    
    <div v-once class="p-3 max-w-3xl mx-auto w-full">
      <p class="subtitle">Come lo dici</p>
      <p>
        La sezione “Come lo dici?” propone, a cadenza settimanale, 
        una serie di cinque immagini a cui occorre associare delle parole. <br>
        Ti suggeriamo di rispondere alle domande senza pensarci troppo,
        indicando quali sono le parole che conosci e che usi abitualmente
        e spontaneamente. Le domande offrono la possibilità di risposta
        multipla e non prevedono risposte giuste o sbagliate. Inoltre, 
        qualora non trovassi tra quelle proposte un’ espressione che tu
        conosci o usi, potrai sempre aggiungerla.
      </p>

      <p class="subtitle">Mappe</p>
      <p>
        La sezione “Mappe” mostra la distribuzione geografica delle parole selezionate dagli utenti tramite le domande “Come lo dici?”.<br>
        I punti sulla mappa corrispondono alle località che gli utenti hanno associato al loro italiano.<br>
        Potrai accedere alla mappa delle parole soltanto dopo aver completato le domande della sezione “Come lo dici?”. <br>
      </p>

    
    </div>
  </div>
</template>

<script>
export default {
  }
</script>

<style scoped>
  .subtitle {
    @apply font-bold text-xl mt-4 mb-2;

  }
</style>